module.exports = __webpack_public_path__ + "img/Postmodernisme_Dag-Solstad.d93cacdb.jpg";